import { Reducer as Reducer_ } from 'redux';
import RequiredDocument_ from '../../data/models/RequiredDocumet';
import * as types from '../actions/actionTypes/docs';
import { IRequiredDocumentHistoryActionType as IRequiredDocumentHistoryActionType_ } from '../actions/doc-actions';

const docHistoryReducer: Reducer_<RequiredDocument_[], IRequiredDocumentHistoryActionType_> = (state = [], { type, payload, }) => {
  switch (type) {
    case types.GET_REQUIRED_DOCUMENTS_HISTORY_SUCCESS:
      return [...payload];

    default:
      return state;
  }
};

export default docHistoryReducer;
